/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { useVacancyGroupId, useVacancyGroupUrl } from '../../../../routing';
import { useFieldHelper } from 'framework/ui/field';

const EditVacancyPublicationButton = (props: EditButtonProps) => {
  const groupId = useVacancyGroupId();
  const { getValue: getPublicationId } = useFieldHelper({
    source: 'id',
  });
  const { getUpdatePublicationUrl } = useVacancyGroupUrl();

  return <EditButton {...props} path={id => getUpdatePublicationUrl(groupId, getPublicationId())} />;
};

export default EditVacancyPublicationButton;
